import { useEffect, useState } from "react"
import Header from "../../components/custom/header"
import "./index.css"
import { useGlobal } from "../../context/global"
import moment from "moment"
import Input from "../../components/custom/input"
import { MemberSearch, MemberSelect, MemberAttendance } from "./member"
import DotLoader from "../../components/info/dotloader"
import ListView from "../../components/holders/listView"
import Bubble from "../../components/holders/bubble"
import PageLoader from "../../components/info/pageloader"
import DP from "../../components/custom/dp"
import Icon from "../../components/custom/icon"

const Attendance = props => {

    const { api, pageLoader, toast } = useGlobal()
    const [date, setDate] = useState()
    const [dates, setDates] = useState()
    const [events, setEvents] = useState()
    const [members, setMembers] = useState()
    const [selectedMember, setSelectedMember] = useState()
    const [attendance, setAttendance] = useState()
    const [attendancePending, setAttendancePending] = useState()
    const [showDates, setShowDates] = useState()


    const getDataforDate = date => {
        api.call('/get-attendance-event-data', { date }).then(res => {

            const events = res.data[0]
            const members = res.data[1]
            setEvents(events)
            setMembers(members)

            api.call('/get-attendance', { date }).then(res => {
                setAttendance(res.data)
            }).catch(err => {
                console.log(err)
            })

            pageLoader.hide()
        }).catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        // get all dates from the calendar
        api.call('/get-attendance-dates').then(res => {
            const d = res.data.map(d => d.startDate)

            // store all dates as a state
            setDates(d)

            // set the next date as display date
            var date = d[0]
            const today = moment().format("YYYY-MM-DD")
            for (let i = 0; i < d.length; i++) {
                if (today >= d[i]) {
                    date = today == d[i] ? d[i] : (i == 0 ? date : d[i - 1])
                    break
                }
            }
            setDate(date)
        }).catch(err => {
            console.log(err)
        })
    }, [])

    useEffect(() => {
        if (dates && date) {
            pageLoader.show('Fetching data..')
            getDataforDate(date)
        }
    }, [date])

    const handleMemberSelect = member => {
        member.courseID = member.courseID || "SOS"
        setSelectedMember(member)
    }

    const memberListMap = member => <MemberSearch member={member} key={member.id} onClick={handleMemberSelect} />

    const filterFunc = (mem, searchKey) => {
        const isName = isNaN(searchKey)
        const memberKey = mem[isName ? 'name' : 'phone'].toLowerCase().replace(/\s+/g, "")
        searchKey = searchKey.toLowerCase().replace(/\s+/g, "")
        return memberKey.includes(searchKey)
    }

    const clearSelectedMember = () => {
        setSelectedMember(null)
    }

    const markSelectedMember = (member, selectedEvent) => {
        setAttendancePending(true)

        if (selectedEvent) {

            const participantID = member.phone
            const eventID = selectedEvent
            const phone = participantID
            const time = moment().format("HH:mm")
            const attendance = 1
            const remarks = ""
            const name = member.name

            const payload = { participantID, eventID, phone, time, attendance, remarks, name }

            api.call('/update-attendance', { date, payload })
                .then(res => {
                    setSelectedMember(null)
                    setAttendance(res.data)
                    toast.show(`${name.split(' ')[0]} marked!`)
                }).catch(err => {
                    alert(`${err}`)
                }).finally(() => {
                    setAttendancePending(false)
                })
        } else {
            alert(`No event found for the courseID ${member.courseID}`)
        }
    }

    const attendanceMap = member => <MemberAttendance member={member} key={`${member.id}-${member.name}`} />

    const handleDateChangeClick = () => {
        setShowDates(true)
    }

    const handleDateSelect = dt => {
        setDate(dt)
        setShowDates(false)
    }

    return (
        <div className="att-root">
            <Header>
                {date ? <div className="flex-row att-header">
                    <div className="att-att">Attendance on </div>
                    <div className="att-date-change" onClick={handleDateChangeClick}>{moment(date, "YYYY-MM-DD").format("Do MMM 'YY")}</div>
                </div> : <DotLoader text={'Attendance'} className={'att-att'} />}
            </Header>

            {showDates && dates ? <Bubble dark className='att-dates-buuble'>
                {
                    dates.map(dt => <div
                        className={`att-date-item ${date == dt ? 'selected' : ''}`}
                        onClick={() => handleDateSelect(dt)}>
                        {moment(dt).format("Do MMM YYYY")}
                    </div>)
                }
            </Bubble> : null}

            {selectedMember && <Bubble dark>
                <MemberSelect member={selectedMember} onSelect={markSelectedMember} events={events} onClear={clearSelectedMember} />
            </Bubble>}

            {attendancePending ? <PageLoader text={"Updating..."} block dark /> : null}

            <div className="att-body body">

                <div className="att-search-cont">
                    <div className="att-search">
                        <Input
                            placeholder="Search name or phone to mark ..."
                            list={members}
                            listMap={memberListMap}
                            filter={filterFunc}
                            auto
                        />
                    </div>
                </div>

                <div className="att-event-cont flex-col flex-align-center">
                    {
                        events ? events.map(event => {
                            return (
                                <div className="att-event-main flex-row flex-space-between">

                                    <div className="flex-row">
                                        <div className="flex-row flex-align-center relative">
                                            <DP badge={
                                                {
                                                    size: [5, 3],
                                                    color: 'var(--surface)',
                                                    icon: {
                                                        size: [3.5, 3],
                                                        name: 'sprint',
                                                        color: 'white'
                                                    }
                                                }
                                            } url={`https://cdn.iskconmysore.org/content?path=folkapp/logos/${event.courseID}.png`} size={15} />
                                        </div>

                                        <div className="flex-col flex-justify-center att-event-det">

                                            <div className="bold att-event-name">{event.eventName}</div>

                                            <div className="flex-col att-event-det2-cont">

                                                <div className="flex-row flex-align-center att-event-time">
                                                    <Icon name="time" size={[5, 2]} color="#888" />
                                                    <div className="att-event-det2">{`${event.startTime} - ${event.endTime}`}</div>
                                                </div>

                                                <div className="flex-row">
                                                    <div className="flex-row flex-align-center">
                                                        <Icon name="location" size={[5, 2]} color="#888" />
                                                        <div className="att-event-det2">{event.venue}</div>
                                                    </div>

                                                    <div className="flex-row flex-align-center">
                                                        <Icon name="mic" size={[5, 2]} color="#888" />
                                                        <div className="att-event-det2">{event.speaker}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex-row flex-align-center att-event-count">{event.attendance}</div>

                                </div>
                            )
                        }) : null
                    }
                </div>

                {
                    attendance ?
                        <div>
                            <ListView list={attendance} map={attendanceMap} />
                        </div>
                        : null
                }
            </div>
        </div>
    )
}

export default Attendance